import React, { useState, useEffect, createRef } from "react";
import { Comment, Avatar, Form, Button, List, Input, Row, Col, Skeleton } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import PagesHeader from "../../components/PageHeader";
import { ArrowLeftOutlined } from "@ant-design/icons";
import moment from "moment";
import ButtonNavigation from "../../components/ButtonNavigation";
import { getComments, addComment } from "../../services/commentsService";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { WEBSITE_URL } from "../../Helper";
import './style.css';

const { TextArea } = Input;

const getRandomColorFromString = (str) => {
  if (!str) return '#ccc';
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const c = (hash & 0x00FFFFFF)
    .toString(16)
    .toUpperCase();

  return "#" + "00000".substring(0, 6 - c.length) + c;
};

const CommentsPage = () => {
  const { req_id } = useParams();
  const navigate = useNavigate();
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [claimNumber, setClaimnaumber] = useState("");

  useEffect(() => {
    fetchComments();
  }, [req_id]);

  const fetchComments = () => {
    setLoading(true);
    getComments(req_id)
      .then((res) => {
        const formattedComments = res.data.map((comment) => ({
          ...comment,
          author: comment.comment_author,
          avatar: comment.comment_author_avatar,
          content: <div dangerouslySetInnerHTML={{ __html: comment.comment_content }} />,
          datetime: moment(comment.comment_date).fromNow(),
          ref: createRef()
        }));
        setComments(formattedComments.reverse());
        setClaimnaumber(res.claim_number ? res.claim_number : req_id);
      })
      .catch((err) => {
        console.error("Error fetching comments:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    if (!value) return;
    setSubmitting(true);

    addComment({ req_id, comment: value })
      .then(() => {
        setValue("");
        fetchComments();
      })
      .catch((err) => {
        console.error("Error adding comment:", err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <div className="inspectionWrapper">
      <div className="inspectionHeader">
        <PagesHeader
          title={<h2 className="comment-page-title">Comments for Claim #{claimNumber}</h2>}
          subTitle="Here you can view and add comments to the claim."
          extra={
            <Button
              type="primary"
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate(-1)}
            >
              Back
            </Button>
          }
        />
      </div>
      <div className="buttonSection">
        <div className="container-xxl">
          <ButtonNavigation />
        </div>
      </div>
      <div className="inspectionWrapInner">
        <div className="container-xxl">
          <Row justify="center">
            <Col span={12}>
              {loading ? (
                <div>
                  {[...Array(3)].map((_, i) => (
                    <Skeleton key={i} avatar paragraph={{ rows: 2 }} active className="comment-skeleton" />
                  ))}
                </div>
              ) : (
                <>
                  <h3 className="comment-page-title">Comments for Claim #{claimNumber}</h3>
                  <List
                    className="comment-list"
                    header={`${comments.length} ${comments.length > 1 ? "comments" : "comment"}`}
                    itemLayout="horizontal"
                    dataSource={comments}
                    renderItem={(item) => (
                      <CSSTransition nodeRef={item.ref} key={item.comment_id} timeout={500} classNames="comment-item">
                        <li ref={item.ref}>
                          <Comment
                            author={item.author}
                            avatar={
                              item.avatar ? (
                                <Avatar src={item.avatar} alt={item.author} />
                              ) : (
                                <Avatar style={{ backgroundColor: getRandomColorFromString(item.author) }}>
                                  {item.author && item.author.charAt(0).toUpperCase()}
                                </Avatar>
                              )
                            }
                            content={item.content}
                            datetime={item.datetime}
                          />
                        </li>
                      </CSSTransition>
                    )}
                  />
                </>
              )}

              <Comment
                avatar={
                  <Avatar
                    src={`${WEBSITE_URL}/wp-content/uploads/2022/08/logo-placeholder.png`}
                    alt="You"
                  />
                }
                content={
                  <>
                    <Form.Item>
                      <TextArea
                        rows={4}
                        onChange={(e) => setValue(e.target.value)}
                        value={value}
                        placeholder="Write a comment..."
                      />
                    </Form.Item>
                    <Form.Item>
                      <Button
                        htmlType="submit"
                        loading={submitting}
                        onClick={handleSubmit}
                        type="primary"
                      >
                        Add Comment
                      </Button>
                    </Form.Item>
                  </>
                }
              />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default CommentsPage;